/**
 * kit-cart-grouping.js -- v3.3 -- 2026 06 11
 * ---------------------------------------------------------------------------
 * Groups kit items in Focal's cart page (table) and cart drawer (div).
 *
 * HOW TO INSTALL
 * 1. Upload to assets/
 * 2. In layout/theme.liquid, add just before </body>:
 *    <script src="{{ 'kit-cart-grouping.js' | asset_url }}" defer></script>
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var STYLE_ID = 'kit-cart-grouping-styles';

  // -- Styles ----------------------------------------------------------------

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [

      /* -------------------------------------------------------
         TABLE MODE  (cart page)
         Clean outer-box appearance. Only the first and last
         cells in each row carry the outer left/right border so
         there are no internal vertical dividers.
      -------------------------------------------------------- */

      /* Force border-collapse so row separators and the bottom border
         run all the way across without gaps between cells */
      '.line-item-table, table.line-item-table {',
      '  border-collapse: collapse !important;',
      '}',

      /* Header row - dark banner across all columns */
      'tr.kcg-header-row > td {',
      '  padding: 0.65rem 1rem !important;',
      '  background: #1a1a1a !important;',
      '  color: #fff !important;',
      '  border: none !important;',
      '  border-top:   2px solid #1a1a1a !important;',
      '  border-left:  2px solid #1a1a1a !important;',
      '  border-right: 2px solid #1a1a1a !important;',
      '}',

      /* All cells in kit rows: reset Focal borders, add outer side borders */
      'tr.kcg-kit-item > td {',
      '  background: #fff !important;',
      '  border: none !important;',          /* clear ALL Focal borders first */
      '  border-bottom: 1px solid #efefef !important;', /* light row divider */
      '  vertical-align: middle !important;',
      '}',
      'tr.kcg-kit-item > td:first-child {',
      '  border-left: 2px solid #1a1a1a !important;',
      '}',
      'tr.kcg-kit-item > td:last-child {',
      '  border-right: 2px solid #1a1a1a !important;',
      '}',
      /* Bottom edge of the kit box */
      'tr.kcg-kit-last > td {',
      '  border-bottom: 2px solid #1a1a1a !important;',
      '}',

      /* Gap row between multiple kits */
      'tr.kcg-gap-row > td {',
      '  border: none !important;',
      '  background: transparent !important;',
      '  padding: 6px 0 !important;',
      '  height: 6px !important;',
      '}',

      /* Hide all line-item properties (catches visible & hidden _props) */
      'tr.kcg-kit-item .line-item__properties,',
      'tr.kcg-kit-item .cart-item__properties,',
      'tr.kcg-kit-item [class*="properties"],',
      'tr.kcg-kit-item dl {',
      '  display: none !important;',
      '}',

      /* PRODUCT CELL - hide Focal's own unit price (but NOT our injected .kcg-price-inline) */
      'tr.kcg-kit-item td:first-child [class*="price"]:not(.kcg-price-inline),',
      'tr.kcg-kit-item td:first-child .product-option {',
      '  display: none !important;',
      '}',
      /* Our injected price sits below the variant name in the product cell */
      'tr.kcg-kit-item .kcg-price-inline {',
      '  display: block;',
      '  font-size: 0.9rem;',
      '  font-weight: 600;',
      '  margin-top: 0.3rem;',
      '  color: #1a1a1a;',
      '}',

      /* QUANTITY CELL - Focal sets display:block on this td, which means it
         doesn't participate in table-cell height equalisation and ends up
         shorter than the product/total cells, breaking the border alignment.
         Forcing display:table-cell restores normal table behaviour. */
      'tr.kcg-kit-item td:nth-child(2) {',
      '  display: table-cell !important;',
      '  text-align: center !important;',
      '  vertical-align: middle !important;',
      '}',

      /* TOTAL CELL - show normally; right border closes the kit box */
      'tr.kcg-kit-item td:last-child {',
      '  text-align: right !important;',
      '  vertical-align: middle !important;',
      '  padding-right: 1.2rem !important;',
      '}',

      /* -------------------------------------------------------
         DIV / DRAWER MODE
      -------------------------------------------------------- */

      '.kcg-group {',
      '  border: 2px solid #1a1a1a;',
      '  border-radius: 0.5rem;',
      '  overflow: hidden;',
      '  margin-bottom: 1rem;',
      '}',
      '.kcg-group > .kcg-header {',
      '  background: #1a1a1a;',
      '  color: #fff;',
      '  padding: 0.6rem 0.9rem;',
      '}',
      '.kcg-group .line-item__content-wrapper {',
      '  display: flex !important;',
      '  flex-direction: row !important;',
      '  align-items: center !important;',
      '  gap: 0.75rem !important;',
      '  padding: 0.65rem 0.9rem !important;',
      '  border-bottom: 1px solid #f0f0f0;',
      '  background: #fff;',
      '}',
      '.kcg-group > *:last-child .line-item__content-wrapper { border-bottom: none; }',
      /* Image */
      '.kcg-group .line-item__image-container,',
      '.kcg-group .cart-item__image-wrapper,',
      '.kcg-group .line-item__media {',
      '  flex-shrink:0!important; width:48px!important; height:48px!important;',
      '  min-width:48px!important; border-radius:0.3rem; overflow:hidden;',
      '}',
      '.kcg-group .line-item__image-container img,',
      '.kcg-group .cart-item__image-wrapper img,',
      '.kcg-group .line-item__media img,',
      '.kcg-group .line-item__content-wrapper > img {',
      '  width:48px!important; height:48px!important; min-width:48px!important;',
      '  object-fit:contain!important; border-radius:0.3rem;',
      '}',
      /* Name + price column */
      '.kcg-group .line-item__meta,',
      '.kcg-group .cart-item__details,',
      '.kcg-group .line-item__info {',
      '  flex:1!important; min-width:0!important;',
      '  display:flex!important; flex-direction:column!important; gap:0.1rem!important;',
      '}',
      /* Hide properties only (qty stepper kept visible) */
      '.kcg-group .line-item__properties,',
      '.kcg-group .cart-item__properties,',
      '.kcg-group [class*="properties"],',
      '.kcg-group dl { display:none!important; }',
      /* Keep Remove link */
      '.kcg-group [data-line-item-remove],',
      '.kcg-group .line-item__remove,',
      '.kcg-group .cart-item__delete {',
      '  display:block!important; font-size:0.75rem!important; margin-top:0.25rem!important;',
      '}',

      /* -------------------------------------------------------
         Shared header
      -------------------------------------------------------- */
      '.kcg-header-inner { display:flex; flex-direction:column; gap:0.15rem; }',
      '.kcg-colour { font-size:0.8rem; font-weight:700; letter-spacing:0.04em; text-transform:uppercase; }',
      '.kcg-engraving { font-size:0.75rem; opacity:0.8; font-style:italic; }'

    ].join('\n');
    document.head.appendChild(s);
  }

  // -- Core grouping ---------------------------------------------------------
  //
  // Confirmed via DevTools: Focal uses #mini-cart-form (inside cart-drawer#mini-cart)
  // as the single container for cart items in BOTH the cart page and the drawer.
  // There is no separate cart-page form. We scope to #mini-cart and let the
  // table/div auto-detection decide which layout to apply.

  function applyGrouping(cartItems) {
    if (!cartItems || cartItems.length === 0) return;

    // Build shared kit metadata from cart items
    var groupMeta  = {};
    var groupOrder = [];
    var itemKitIds = [];

    cartItems.forEach(function (item, i) {
      var props = item.properties || {};
      var kitId = props['_kit_id'] || null;
      itemKitIds[i] = kitId;
      if (kitId && !groupMeta[kitId]) {
        groupMeta[kitId] = {
          colour:    props['_kit_colour']    || '',
          engraving: props['_kit_engraving'] || '',
          font:      props['_kit_font']      || ''
        };
        groupOrder.push(kitId);
      }
    });

    if (groupOrder.length === 0) return;

    // Two separate contexts confirmed via DevTools:
    //
    // CART PAGE  - DIV.cart > DIV.cart__content > TABLE (no #mini-cart element)
    // CART DRAWER - cart-drawer#mini-cart (not present on /cart page)
    //
    // We try both; whichever is in the DOM gets grouping applied.

    // Cart page
    var cartPage = document.querySelector('.cart__content') ||
                   document.querySelector('.cart');
    if (cartPage) {
      applyGroupingToContainer(cartPage, cartItems, itemKitIds, groupMeta, groupOrder);
    }

    // Cart drawer
    var drawer = document.getElementById('mini-cart') ||
                 document.querySelector('cart-drawer');
    if (drawer) {
      applyGroupingToContainer(drawer, cartItems, itemKitIds, groupMeta, groupOrder);
    }
  }

  function applyGroupingToContainer(container, cartItems, itemKitIds, groupMeta, groupOrder) {
    var wrappers = Array.prototype.slice.call(
      container.querySelectorAll('.line-item__content-wrapper')
    );
    if (wrappers.length === 0) return;

    // Detect layout: if wrapper's grandparent is a <tr>, we're in table mode
    var productCell0 = wrappers[0].parentElement;
    var isTable = productCell0 &&
                  productCell0.parentElement &&
                  productCell0.parentElement.tagName.toLowerCase() === 'tr';

    // Build item element array (tr in table mode, productCell in div mode)
    var itemEls = wrappers.map(function (w) {
      return isTable ? w.parentElement.parentElement : w.parentElement;
    }).filter(Boolean);

    // Deduplicate
    var seen = [];
    itemEls = itemEls.filter(function (el) {
      if (seen.indexOf(el) > -1) return false;
      seen.push(el);
      return true;
    });

    // Must match - if counts differ the DOM isn't ready yet
    if (itemEls.length !== cartItems.length) return;

    // Tear down previous grouping within this container.
    // IMPORTANT: remove .kcg-header divs BEFORE unwrapping .kcg-group -
    // otherwise the header gets moved to the parent as a loose element and
    // accumulates on each subsequent run (the duplicate-header bug).
    container.querySelectorAll('.kcg-group').forEach(function (g) {
      g.querySelectorAll('.kcg-header').forEach(function (h) {
        h.parentNode.removeChild(h);
      });
      while (g.firstChild) g.parentNode.insertBefore(g.firstChild, g);
      g.parentNode.removeChild(g);
    });
    container.querySelectorAll('tr.kcg-header-row, tr.kcg-gap-row').forEach(function (r) {
      r.parentNode && r.parentNode.removeChild(r);
    });
    container.querySelectorAll('tr.kcg-kit-item').forEach(function (r) {
      r.classList.remove('kcg-kit-item', 'kcg-kit-first', 'kcg-kit-last');
    });
    container.querySelectorAll('.kcg-price-inline').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
    // Catch any stray .kcg-header divs left outside a group
    container.querySelectorAll('.kcg-header').forEach(function (h) {
      h.parentNode && h.parentNode.removeChild(h);
    });

    // Apply each group
    groupOrder.forEach(function (kitId, groupIdx) {
      var meta    = groupMeta[kitId];
      var members = itemEls.filter(function (_, i) { return itemKitIds[i] === kitId; });
      var prices  = cartItems
        .filter(function (_, i) { return itemKitIds[i] === kitId; })
        .map(function (item) { return item.price; });

      if (members.length === 0) return;

      if (isTable) {
        applyTableGroup(members, prices, buildHeaderHTML(meta), groupIdx > 0);
      } else {
        applyDivGroup(members, buildHeaderHTML(meta));
      }
    });
  }

  // -- TABLE mode ------------------------------------------------------------

  function applyTableGroup(rows, prices, headerHTML, addGapBefore) {
    var parent = rows[0].parentNode;

    if (addGapBefore) {
      var gapRow = document.createElement('tr');
      gapRow.className = 'kcg-gap-row';
      var gapCell = document.createElement('td');
      gapCell.colSpan = 99;
      gapRow.appendChild(gapCell);
      parent.insertBefore(gapRow, rows[0]);
    }

    var headerRow = document.createElement('tr');
    headerRow.className = 'kcg-header-row';
    var headerCell = document.createElement('td');
    headerCell.colSpan = 99;
    headerCell.innerHTML = headerHTML;
    headerRow.appendChild(headerCell);
    parent.insertBefore(headerRow, rows[0]);

    rows.forEach(function (row, i) {
      row.classList.add('kcg-kit-item');
      if (i === 0)               row.classList.add('kcg-kit-first');
      if (i === rows.length - 1) row.classList.add('kcg-kit-last');

      // Inject price below the variant/colour name, inside the text meta container.
      // Appending to the outer td lands below the image; we need to go inside the
      // meta/info div that holds the product name and variant text.
      var cells = row.querySelectorAll('td');
      var productCell = cells[0];
      if (productCell && prices[i] != null) {
        var priceSpan = document.createElement('span');
        priceSpan.className = 'kcg-price-inline';
        priceSpan.textContent = formatMoney(prices[i]);
        var metaEl = productCell.querySelector(
          '.line-item__meta, .line-item__info, .cart-item__details, .line-item__content'
        );
        (metaEl || productCell).appendChild(priceSpan);
      }
    });
  }

  // -- DIV mode --------------------------------------------------------------

  function applyDivGroup(itemEls, headerHTML) {
    var wrapper = document.createElement('div');
    wrapper.className = 'kcg-group';
    var header = document.createElement('div');
    header.className = 'kcg-header';
    header.innerHTML = headerHTML;
    itemEls[0].parentNode.insertBefore(wrapper, itemEls[0]);
    wrapper.appendChild(header);
    itemEls.forEach(function (el) { wrapper.appendChild(el); });
  }

  // -- Header HTML -----------------------------------------------------------

  function buildHeaderHTML(meta) {
    var colour = '<span class="kcg-colour">'
               + esc(meta.colour ? meta.colour + ' Kit' : 'Kit')
               + '</span>';
    var engraving = meta.engraving
      ? '<span class="kcg-engraving">'
        + '&ldquo;' + esc(meta.engraving) + '&rdquo;'
        + (meta.font ? ' &middot; ' + esc(meta.font) : '')
        + '</span>'
      : '';
    return '<div class="kcg-header-inner">' + colour + engraving + '</div>';
  }

  // -- Money formatting ------------------------------------------------------
  // Price from /cart.js is in cents; format using the page's currency symbol.

  function formatMoney(cents) {
    // Prefer the explicit currency set in KitBuilder settings
    // \u escapes used for non-ASCII currency symbols (Shopify CDN requires ASCII-only files)
    var sym = '\u20AC'; // EUR -- safe default for ouichef.kitchen
    if (window.KitBuilder && window.KitBuilder.settings && window.KitBuilder.settings.currency) {
      var ISO_MAP = { EUR: '\u20AC', USD: '$', GBP: '\u00A3', CAD: 'CA$', AUD: 'A$', JPY: '\u00A5', CHF: 'CHF ' };
      sym = ISO_MAP[window.KitBuilder.settings.currency] || sym;
    } else if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      var ISO_MAP2 = { EUR: '\u20AC', USD: '$', GBP: '\u00A3', CAD: 'CA$', AUD: 'A$', JPY: '\u00A5', CHF: 'CHF ' };
      sym = ISO_MAP2[window.Shopify.currency.active] || sym;
    }
    return sym + (cents / 100).toFixed(2);
  }

  // -- Observer (module-scope so runGrouping can pause it) ------------------

  var observer = new MutationObserver(debounce(runGrouping, 400));

  // -- Debounced fetch + apply -----------------------------------------------

  var _timer = null;

  function runGrouping() {
    clearTimeout(_timer);
    _timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Pause observer so our own DOM changes don't re-trigger grouping.
          observer.disconnect();
          applyGrouping(cart.items);
          // Resume - only external changes (Focal re-renders) will trigger again.
          observer.observe(document.body, {
            childList: true, subtree: true, attributes: false, characterData: false
          });
        })
        .catch(function () {});
    }, 400);
  }

  // -- Boot ------------------------------------------------------------------

  function boot() {
    injectStyles();
    runGrouping();

    ['cart:open', 'cart:refresh', 'cart-drawer:open', 'cartDrawer:open', 'drawer:open']
      .forEach(function (evt) { document.addEventListener(evt, runGrouping); });

    observer.observe(document.body, {
      childList: true, subtree: true, attributes: false, characterData: false
    });
  }

  // -- Utils -----------------------------------------------------------------

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
